<template>
  <div id="app">
    <router-view />
    <div class="backTop" @click="backTop" v-show="flag_scroll">
      <i class="el-icon-arrow-up"></i>
    </div>
  </div>
</template>
<script>
export default {
  name: "App",
  data() {
    return {
      flag_scroll: false,
      scroll: 0,
    };
  },
  methods: {
    backTop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop =
          document.documentElement.scrollTop =
          top -=
            50;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 10);
    },
    //滑动超过200时显示按钮
    handleScroll() {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 300) {
        this.flag_scroll = true;
      } else {
        this.flag_scroll = false;
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
};
</script>
<style lang="scss" scoped>
@import "@//styles/variables.scss";
.backTop {
  position: fixed;
  width: 60px;
  height: 60px;
  bottom: 100px;
  z-index: 100;
  right: 24px;
  border-radius: 50%;
  background: rgba(241, 140, 79, 0.4);
  font-size: 30px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    background: $main-color;
    cursor: pointer;
  }
}
</style>
